import { For, createEffect, createSignal } from "solid-js";
import { TranslationField } from "~/components/TranslationField";
import { useFaqWidget } from "../../../providers/context";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "~/components/ui/accordion";
import { Text } from "~/components/ui/text";
import { Group } from "~/components/ui/group";
import { Card } from "~/components/ui/card";
import { attrv } from "~/util/helpers";
import { cn } from "~/util/utils";
import { FaqArticle } from "../../../types";

export function Toc() {

	const [accordion, setAccordion] = createSignal<string[]>([]);
	
	const { 
		setSelected, 
		selected, 
		searchedArticles, 
		setOpenSheet 
	} = useFaqWidget();

	createEffect(() => {
		const article = selected();
		const toc = searchedArticles();

		if (!article) {
			return;
		}

		const section = toc.find(section => section.articles.some(a => a.id === article.id));
		setAccordion(section ? [section.id] : []);
	});

	const onClickArticle = (article: FaqArticle) => {
		setSelected(article);
		setOpenSheet(false);
	}

	return (
		<Accordion
			class="w-full"
			collapsible
			value={accordion()}
			onChange={setAccordion}
		>
			<For each={searchedArticles()}>
				{(section) => (
					<Card class="mb-4 border-gray-100">
						<AccordionItem class="border-b-0" value={section.id}>
							<AccordionTrigger class="px-4">
								<Group class="flex-1">
									<div
										class="rounded-sm overflow-hidden min-w-12 min-h-12 max-w-12 p-2 max-h-12 content-center"
										style={{ "background-color": section.color }}
									>
										<img
											class="w-full h-full"
											src={section.image}
											alt={section.title}
											role="img"
										/>
									</div>
									<div>
										<Text class="block text-left">
											<TranslationField key={section.title} />
										</Text>
										<Text
											class="text-muted-foreground font-normal text-left mt-1 block"
											size="sm"
										>
											{section.articles.length.toString()} vragen
										</Text>
									</div>
								</Group>
							</AccordionTrigger>
							<AccordionContent
								class="[&>div]:pb-0"
							>
								<For each={section.articles}>
									{(article) => (
										<div
											class={cn(
												"px-3 !py-4 border-b cursor-pointer transition-all",
												"first:border-t last:border-b-transparent",
												"hover:bg-gray-50 active:bg-gray-100",
												"data-[selected]:bg-gray-100 data-[selected]:border-l-[5px]",
											)}
											data-selected={attrv(article.id === selected()?.id)}
											onClick={() => onClickArticle(article)}
											style={{ "border-left-color": section.color || "hsl(var(--accent-foreground))" }}
										>
											<TranslationField key={article.question} />
										</div>
									)}
								</For>
							</AccordionContent>
						</AccordionItem>
					</Card>
				)}
			</For>
		</Accordion>
	);
}